
import { Map, List, fromJS } from 'immutable';
import { combineReducers } from 'redux-immutable'
import requestStatus from '../../constants/requestStatus'
import actionTypes from '../../actions/actionTypes'
import { PROGRAM_DEFAULT } from '../../constants/state'
import itemSelectionsDisplayReducer from './itemSelectionsDisplay';
import itemSelectionsReducer from './itemSelections';
import itemCollectionsReducer from './itemCollections'
import highlightsReducer from './highlights';
import cliMoviesReducer from './cliMovies';
import metaMoviesReducer from './metaMovies';
import attributesReducer from './attributes';
import movieMappingsReducer from './movieMappings';
import movieExtensionsReducer from './movieExtensions';
import { dummyReducerFacory } from '../helpers';
import adsReducer from './ads';
import pmMoviesReducer from './pmMovies';
import updateProgramReducer from './updateProgram';
import weischerAdsReducer from './weischerAds';
import hasUpdatesReducer from './hasUpdates';
import advertisementsReducer from './advertisements';
import updatesReducer from './updates';
import elbenwaldBrandMappingsReducer from './elbenwaldBrandMappings';
import elbenwaldBrandsReducer from './elbenwaldBrands';

const INIT_STATE = Map({})


const handleProgramRequest = state => state.set('status', requestStatus.REQUEST_PENDING).set('error', Map());
const handleProgramSuccess = (state, action) => fromJS(action.programData).setIn(['movieExtensions', 'itemsToReset'], List()).set('status', requestStatus.REQUEST_SUCCESS)
const handleCreateSuccess = state => state.set('status', requestStatus.REQUEST_SUCCESS)
const handleProgramError = (state, action) => state.set('status', requestStatus.REQUEST_ERROR).setIn(['error', 'message'], action.errorMessage)



const combinedReducer = combineReducers({      
    status:                 dummyReducerFacory(PROGRAM_DEFAULT.status),
    error:                  dummyReducerFacory(fromJS(PROGRAM_DEFAULT.error)),
    hasUpdates:             hasUpdatesReducer,
    updates:                updatesReducer,
    pyMovies:               dummyReducerFacory(fromJS(PROGRAM_DEFAULT.pyMovies)),
    dieselv2Movies:         dummyReducerFacory(fromJS(PROGRAM_DEFAULT.dieselv2Movies)),
    cortecMovies:           dummyReducerFacory(fromJS(PROGRAM_DEFAULT.cortecMovies)),
    khMovies:               dummyReducerFacory(fromJS(PROGRAM_DEFAULT.khMovies)),
    compesoMovies:          dummyReducerFacory(fromJS(PROGRAM_DEFAULT.compesoMovies)),
    cinemas:                dummyReducerFacory(fromJS(PROGRAM_DEFAULT.cinemas)),
    pmMovies:               pmMoviesReducer,
    metaMovies:             metaMoviesReducer,
    cliMovies:              cliMoviesReducer,
    elbenwaldBrandMappings: elbenwaldBrandMappingsReducer,
    elbenwaldBrands:        elbenwaldBrandsReducer,
    itemSelectionsDisplay:  itemSelectionsDisplayReducer,
    itemSelections:         itemSelectionsReducer,
    itemCollections:        itemCollectionsReducer,
    performances:           dummyReducerFacory(fromJS(PROGRAM_DEFAULT.performances)),
    highlights:             highlightsReducer,
    ads:                    adsReducer,  
    advertisements:         advertisementsReducer,     
    weischerAds:            weischerAdsReducer,              
    attributes:             attributesReducer,
    movieMappings:          movieMappingsReducer,
    movieExtensions:        movieExtensionsReducer,
    updateProgram:          updateProgramReducer,
})


const programDataRootReducer = (state = INIT_STATE, action) => {
    switch(action.type){
        case actionTypes.PROGRAM_FETCH_REQUEST:
        case actionTypes.PROGRAM_GET_REQUEST:
        case actionTypes.PROGRAM_UPDATE_REQUEST:
        case actionTypes.PROGRAM_FILTER_REQUEST:
        case actionTypes.PROGRAM_CREATE_ITEM_REQUEST:
            state = handleProgramRequest(state, action);
            break;
        case actionTypes.PROGRAM_FETCH_SUCCESS:
        case actionTypes.PROGRAM_GET_SUCCESS:
        case actionTypes.PROGRAM_UPDATE_SUCCESS:
        case actionTypes.PROGRAM_FILTER_SUCCESS:
            state = handleProgramSuccess(state, action);
            break;
        case actionTypes.PROGRAM_CREATE_ITEM_SUCCESS:
            state = handleCreateSuccess(state);
            break;
        case actionTypes.PROGRAM_FETCH_ERROR:
        case actionTypes.PROGRAM_GET_ERROR:
        case actionTypes.PROGRAM_UPDATE_ERROR:
        case actionTypes.PROGRAM_FILTER_ERROR:
        case actionTypes.PROGRAM_CREATE_ITEM_ERROR:
            state = handleProgramError(state, action)
            break;
    }

    return combinedReducer(state, action)
}

export default programDataRootReducer